export default {
  title: 'Transférer le site web',
  buttons: {
    cancel: 'Annuler',
    transfer: 'Transférer',
  },
  fields: {
    target_franchise: {
      label: 'Franchise cible',
      description: 'Sélectionner la franchise vers laquelle transférer le site web',
    },
    sync_companies: {
      label: "Associations d'entreprises",
      description: 'Associer les entreprises de la franchise cible aux entreprises de la vitrine',
      franchise_company: 'Entreprise franchise',
      storefront_company: 'Entreprise vitrine',
      select_franchise_company: "Sélectionner l'entreprise franchise",
      select_storefront_company: "Sélectionner l'entreprise vitrine",
      franchise_company_required: "L'entreprise franchise est obligatoire",
      storefront_company_required: "L'entreprise vitrine est obligatoire",
    },
  },
  toasts: {
    failed_to_load_companies: 'Échec du chargement des entreprises',
    no_companies_selected: "Veuillez ajouter au moins une association d'entreprises",
    failed_to_transfer: 'Échec du transfert du site web',
    transfer_success: 'Site web transféré avec succès',
    franchise_already_connected: 'La franchise cible est déjà connectée à un site web',
  },
};
